import { render, staticRenderFns } from "./participaciones-como-evaluador.vue?vue&type=template&id=34455960&"
import script from "./participaciones-como-evaluador.component.ts?vue&type=script&lang=ts&"
export * from "./participaciones-como-evaluador.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports